export const REACT_APP_THEME_NAME = process.env.NEXT_PUBLIC_THEME_NAME || "gott";
export const REACT_APP_COPYRIGHT = process.env.REACT_APP_COPYRIGHT;

export const CUSTOMER_LOGO = process.env.REACT_APP_CUSTOMER_LOGO;
export const CUSTOMER_LOGO_DARK = process.env.REACT_APP_CUSTOMER_LOGO_DARK;
export const CUSTOMER_LOGO_SECONDARY = process.env.REACT_APP_CUSTOMER_LOGO_SECONDARY;
export const CUSTOMER_LOGO_SECONDARY_DARK = process.env.REACT_APP_CUSTOMER_LOGO_SECONDARY_DARK;
export const CUSTOMER_LOGIN_IMAGE = process.env.REACT_APP_LOGIN_IMAGE;
export const CUSTOMER_DEFAULT_ROUTE = process.env.REACT_APP_CUSTOMER_DEFAULT_ROUTE;
export const CUSTOMER_HERO_IMAGE = process.env.REACT_APP_HERO_IMAGE;

export const ENABLE_DECISION_INFERENCE = process.env.REACT_APP_DECISION_INFERENCE === "true";

export const SHOW_SECONDARY_LOGO_IN_SIDEBAR = process.env.REACT_APP_SHOW_SECONDARY_LOGO_IN_SIDEBAR === "true";
export const SHOW_SECONDARY_LOGO_IN_LOGIN = process.env.REACT_APP_SHOW_SECONDARY_LOGO_IN_LOGIN === "true";

// Menu Flags Begin
// Consultas menu flags
export const ENABLE_CONSULTAS_MENU = process.env.REACT_APP_ENABLE_CONSULTAS === "true";
export const ENABLE_CONSULTA_VEICULO_DETRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTA_VEICULO_DETRAN === "true";
export const ENABLE_CONSULTA_CONDUTORES_DETRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTA_CONDUTORES_DETRAN === "true";
export const ENABLE_CONSULTAS_SENATRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTAS_SENATRAN === "true";
export const ENABLE_CONSULTA_HISTORICO_MULTAS_CONDUTORES_DETRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTA_HISTORICO_MULTAS_CONDUTORES_DETRAN_MENU === "true";
export const ENABLE_CONSULTA_PROCESSO_BLOQUEIO_CONDUTORES_DETRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTA_PROCESSO_BLOQUEIO_CONDUTORES_DETRAN_MENU === "true";
export const ENABLE_CONSULTA_HISTORICO_INFRACAO_DETRAN_MENU = process.env.REACT_APP_ENABLE_CONSULTA_HISTORICO_INFRACAO_DETRAN_MENU === "true";
export const ENABLE_BOAT = process.env.REACT_APP_ENABLE_BOAT === "true"
// Boletim de Ocorrência: upload de vídeos no passo de anexos.
// Opt-out: habilitado por padrão; defina REACT_APP_ENABLE_BOAT_VIDEO_UPLOAD=false para desabilitar.
export const ENABLE_BOAT_VIDEO_UPLOAD = process.env.REACT_APP_ENABLE_BOAT_VIDEO_UPLOAD !== "false"
// Boletim de Ocorrência: máximo de imagens anexáveis no passo de anexos.
export const BOAT_MAX_IMAGES = Number(process.env.REACT_APP_BOAT_MAX_IMAGES) || 4

// Cartoes menu flags
export const ENABLE_CARTOES_MENU = process.env.REACT_APP_ENABLE_CARTOES === "false";

// Estatisticas menu (cards and charts)
export const ENABLE_STATISTICS_MENU = process.env.REACT_APP_ENABLE_STATISTICS === "true";
// Menu Flags End

export const TRAFFIC_VIOLATIONS_MAX_IMAGES = process.env.TRAFFIC_VIOLATIONS_MAX_IMAGES ?? 2;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const REACT_APP_USE_GRAY_THEME = process.env.REACT_APP_USE_GRAY_THEME === "true";

// Integrations
export const REACT_APP_ANALYTICS_URL= process.env.REACT_APP_ANALYTICS_URL;
export const AWS_CHAT_ENDPOINT = process.env.REACT_APP_AWS_CHAT_ENDPOINT;
export const COMPANY_OWNER_LOGO = process.env.REACT_APP_COMPANY_OWNER_LOGO;
export const COMPANY_LOGO = process.env.REACT_APP_COMPANY_LOGO;